import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";


export default class PageInvoiceSearch extends PageCommon {
	constructor() {
		super();
	}
	init( $data ) {
		super.init($data);
		this.data = $data;
		this.showPreloader(false);
		Pqp.trace("PageDefault - Hello world"); 

		// dispaccio un evento globale
		try {
			this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
		} catch (error) {
			console.log(error);
		}

		if ($('.js-filter-type').val() == 0) {
			$('.js-dashboard-filter').show();
			$('.js-raw-filter').hide();
		} else {
			$('.js-dashboard-filter').hide();
			$('.js-raw-filter').show();
        }
		 

		$('.js-filter-type').change(function () {
			let newValue;
			newValue = $(this).val();
			if (newValue == 0) {
				$('.js-dashboard-filter').show();
				$('.js-raw-filter').hide();
			} else {
				$('.js-dashboard-filter').hide();
				$('.js-raw-filter').show();
			}
		});



		$('.js-category').attr('disabled', 'disabled');
		$('.js-subcategory').attr('disabled', 'disabled');

		$('.js-document-type').on('change', this.loadInvoiceCategory.bind(this));

		$('.js-category').on('change', this.loadInvoiceSubCategory.bind(this));

		if (this.data.uidCategory !== "") {
			this.loadInvoiceCategory();
			$('.js-category option[value=' + this.data.uidCategory +']').attr('selected', 'selected');
		}
		if (this.data.uidSubCategory !== "") {
			this.loadInvoiceSubCategory();
			$('.js-subcategory option[value=' + this.data.uidSubCategory + ']').attr('selected', 'selected');
		}

		PageCommon.disable($(".js-btn-search"), true);

		$(".js-customerid").keyup(this.onCheckData.bind(this));
		$(".js-invoiceno").keyup(this.onCheckData.bind(this));
		$(".js-fromdate").keyup(this.onCheckData.bind(this));
		$(".js-todate").keyup(this.onCheckData.bind(this));
		$(".js-journal").keyup(this.onCheckData.bind(this));
		$(".js-category").keyup(this.onCheckData.bind(this));
		$(".js-document-type").keyup(this.onCheckData.bind(this));
		$(".js-subcategory").keyup(this.onCheckData.bind(this));
		$(".js-category-fld").keyup(this.onCheckData.bind(this));
		$(".js-btn-search").on("click", this.onDoSubmit.bind(this));


		this.onCheckData();

		$("body").keydown(this.onSendData.bind(this));
	}

	loadInvoiceCategory() {
		let documentType = $('.js-document-type').val();
		let selectCategory = $('.js-category')
		selectCategory.empty().append('<option selected="selected" value="">Seleziona</option>')
		selectCategory.attr('disabled', 'disabled');
		if (documentType === "0") {
			const categories = this.data.fatture;
			$.each(categories, function (index, category) { selectCategory.append($('<option>', { value: category.Uid, text: category.Label })); });
			selectCategory.removeAttr('disabled');
		} else if (documentType === "1") {
			const categories = this.data.notecredito;
			$.each(categories, function (index, category) { selectCategory.append($('<option>', { value: category.Uid, text: category.Label })); });
			selectCategory.removeAttr('disabled');
		} 
	}

	loadInvoiceSubCategory() {
		let documentType = $('.js-document-type').val();
		let invoiceCategory = $('.js-category').val();
		let selectSubCategory = $('.js-subcategory')
		selectSubCategory.empty().append('<option selected="selected" value="">Seleziona</option>')
		selectSubCategory.attr('disabled', 'disabled');
		if (invoiceCategory != "") {
			if (documentType === "0") {
				const subcategories = this.data.fatture.find(x => x.Uid === invoiceCategory).SubCategories;
				$.each(subcategories, function (index, category) { selectSubCategory.append($('<option>', { value: category.Uid.replace('/','_'), text: category.Label })); });
				if (subcategories.length > 0) {
					selectSubCategory.removeAttr('disabled');
				}
			} else if (documentType === "1") {
				const subcategories = this.data.notecredito.find(x => x.Uid === invoiceCategory).SubCategories;
				$.each(subcategories, function (index, category) { selectSubCategory.append($('<option>', { value: category.Uid.replace('/', '_'), text: category.Label })); });
				if (subcategories.length > 0) {
					selectSubCategory.removeAttr('disabled');
                }
			}
        }
	}

	onCheckData() {
		let CustomerId = $.trim($(".js-customerid").val().trim());
		if (CustomerId.trim() != "") {
			PageCommon.disable($(".js-btn-search"), false);
			return true;
		} else {
			PageCommon.disable($(".js-btn-search"), true);
			return false;
		}
	}

	onSendData(e) {
		if (e.which == 13 && this.onCheckData()) {
			this.onDoSubmit();
		}
	}

	onDoSubmit(e) {
		this.showPreloader(true);
		var state = {
			customerid: $.trim($(".js-customerid").val()),
			invoiceno: $.trim($(".js-invoiceno").val()),
			fromdate: $.trim($(".js-fromdate").val()),
			todate: $.trim($(".js-todate").val()),
			journal: $.trim($(".js-journal").val()),
			category: $.trim($(".js-category-fld").val()),
			number: $.trim($(".js-number").val()),
			filtertype: $.trim($(".js-filter-type").val()),
			documenttype: $.trim($(".js-document-type").val()),
			uidCategory: $.trim($(".js-category").val()),
			uidSubCategory: $.trim($(".js-subcategory").val()),
		};
		StateManager.setViewState("jsSearch", state);
		var args = StateManager._splitUrl(document.location.href);
		let url = "";
		if (this.data !== null && this.data.page !== null) {
			url = "?__pi = " + this.data.page.PageId;
		}
		if (url.length > 0) {
			url += "&";
		} else {
			url += "?";
        }
		url += "_vs=" + encodeURIComponent(args.qPart["_vs"]);
		document.location.href = TheApp.Env.BaseUrlNls + "invoice/list" + url;
	}

}

